import React from "react";
import { Pagination } from "@mui/material";
import RowsPerPageSelector from "./RowsPerPageSelector";

const ListPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  rowsPerPage,
  setRowsPerPage,
}) => {
  return (
    <div className="sticky w-full border-t border-gray-300 bg-white p-2 flex justify-between items-center">
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={onPageChange}
        color="primary"
        shape="rounded"
      />
      <RowsPerPageSelector
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />
    </div>
  );
};

export default ListPagination;
